import React, { FC } from 'react';
import s from './toyCard.module.scss';
import { ArtistView, StoreItemView, Toy } from '@specs/views';
import { collectionMeta, PublicationType, storeItem } from '@prisma/client';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
import cn from 'classnames';
import { ToyCardFooter } from '@components/Cards/ToyCard/ToyCardFooter';
import Link from 'next/link';
import { LinksEnum } from '@specs/navigation';
import { RarityIcon } from '@components/UIKit/RarityIcon/RarityIcon';
import { useTranslation } from '@hooks/useTranslation';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
interface Props {
  id: Toy.Single['id'];
  name: Toy.Single['name'];
  slug: Toy.Single['slug'];
  imageid: Toy.Single['imageid'];
  raritytype: Toy.Single['raritytype'];
  collection: collectionMeta | null | undefined;
  artist: ArtistView | null | undefined;
  firstStoreItem: StoreItemView | undefined;
  myFirstStoreItem: storeItem | undefined;
  haveFigurinesForSale: boolean;
  artistWithCollaborators: (string | undefined)[];
  publication: PublicationType;
}
const calcArtistIconPosition = (i: number) => {
  const offset = 8;
  return `${i * offset}px`;
};
export const ToyCardLoaded: FC<Props> = ({
  name,
  artistWithCollaborators,
  slug,
  imageid,
  collection,
  raritytype,
  haveFigurinesForSale,
  myFirstStoreItem,
  firstStoreItem,
  publication
}) => {
  const {
    translate: tr
  } = useTranslation();
  const isTwin = publication === PublicationType.TWIN;
  return <div className={s.toyCard} data-sentry-component="ToyCardLoaded" data-sentry-source-file="ToyCardLoaded.tsx">
            <div className={s.toyCard__body}>
                <div className={s.toyCard__top}>
                    <div className={s.toyCard__row}>
                        <div className={s.toyCard__artistRow}>
                            {artistWithCollaborators.map((shortId, i) => <div key={shortId} style={{
              right: calcArtistIconPosition(i)
            }} className={s.toyCard__artist}>
                                        {!!shortId && <ArtistAvatar shortId={shortId} srcSet={[{
                height: 24,
                width: 24,
                minMedia: 0
              }]} />}
                                    </div>)}
                        </div>
                        {raritytype && !isTwin && <RarityIcon rarityId={raritytype} width={24} height={24} />}
                        {isTwin && <SpriteIcon name={'twin'} width={24} height={24} />}
                    </div>
                    <Link href={{
          pathname: LinksEnum.TOY,
          query: {
            slug
          }
        }} data-sentry-element="Link" data-sentry-source-file="ToyCardLoaded.tsx">
                        <OptimizedImage boxClassName={cn(s.toyCard__image, '_shadow')} path={'/toys/cards'} cdnId={imageid} fill alt={tr({
            id: 'toy.card.image.title'
          }, {
            name
          })} title={tr({
            id: 'toy.card.image.title'
          }, {
            name
          })} data-sentry-element="OptimizedImage" data-sentry-source-file="ToyCardLoaded.tsx" />
                    </Link>
                </div>
                <div className={s.toyCard__main}>
                    <div className={cn(s.toyCard__name, '_ellipsis')}>
                        {name}
                    </div>
                    {!!collection && <div className={cn(s.toyCard__collection, '_ellipsis')}>
                            {collection.name}
                        </div>}
                </div>
                <ToyCardFooter slug={slug} haveFigurinesForSale={haveFigurinesForSale} myFirstStoreItem={myFirstStoreItem} firstStoreItem={firstStoreItem} data-sentry-element="ToyCardFooter" data-sentry-source-file="ToyCardLoaded.tsx" />
            </div>
        </div>;
};